import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import * as apiConfig from "../../api/config";
import PropTypes from "prop-types";
import { loadBingApi } from "../../api/bingMapsApi"
import "./Create.css";
import Spinner from "../common/Spinner";
import { getDirections, standardisePoint, getRouteClickedInsertionIndex } from "../../api/routeUtilitiesApi";
import MapSwitchControl from "./MapSwitchControl";
import geocoder from 'google-geocoder';
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/autocomplete';

function CreateRouteBingMapView({
    auth,
    mapVariant,
    centre,
    zoom,
    points,
    routeCreatorState,
    draftRoute,
    mapUpdated,
    addRoutePoints,
    deleteRoutePoint,
    moveRoutePoint,
    insertRoutePoint,
    setReCentreOnLoad,
    history,
    map,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [microsoft, setMicrosoft] = useState(null);
    var map;

    const mapRef = useRef(null);
    const locationRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);

    var routePoints = [];
    var draftPolyline;
    var markers = [];
    var movingMarkerPosition;
    var movingMarkerNewPosition;
    var movingMarkerIndex;
    var markerIsMoving = false;

    useEffect(() => {
        if (!microsoft) {
            loadBingApi().then((ms) => {
                setMicrosoft(ms);
            });
        }
    }, []);

    useEffect(() => {
        if (microsoft) {
            setUpMap();
            restoreRouteFromState();
            if (routeCreatorState.reCentreOnLoad) {
                reCentreMap();
                setReCentreOnLoad(false);
            }
        }
    }, [microsoft])

    useEffect(() => {
        if (microsoft) {
            if (!map) {
                setUpMap();
            }
            restoreRouteFromState();
            if (routeCreatorState.reCentreOnLoad) {
                reCentreMap();
                setReCentreOnLoad(false);
            }
        }
    }, [routeCreatorState.plotMode, routeCreatorState.createMode, draftRoute.future.length, mapVariant])

    function convertToMsPoint(latlngs) {
        var msPoints = [];
        latlngs.map(point => {
            msPoints.push(new microsoft.Maps.Location(point.lat, point.lng))
        })
        return msPoints;
    }

    function reCentreMap() {
        var msPointArray = []
        routePoints.map(point => {
            msPointArray.push({ latitude: point.lat, longitude: point.lng });
        });

        var bounds = microsoft.Maps.LocationRect.fromLocations(msPointArray); 
        map.setView({ bounds: bounds });
        handleMapChanged();
    }

    function restoreRouteFromState() {
        if (points.length > 0) {

            map.entities.clear();

            var checkArray = [];
            points.map((point) => {
                checkArray.push({ lat: point.lat, lng: point.lng });
            })

            var newMarkers = []
            points.map((point, index) => {
                var msPoint = new microsoft.Maps.Location(point.lat, point.lng)
                newMarkers.push(createMarker(point, index == 0))

                checkArray.map((p, idx) => {
                    if (p.lat === point.lat && p.lng === point.lng && index != idx) {
                        var newPoint = { lat: point.lat + 0.00001, lng: point.lng + 0.00001, ele: point.ele, dist: point.dist }
                        newPoint = standardisePoint(newPoint);
                        moveRoutePoint(newPoint, index)
                        points.splice(index, 1, newPoint);
                        checkArray.splice(index, 1, newPoint);
                    }
                });

                routePoints.push(point)
            });
            markers = newMarkers;
            reDrawRoute(routePoints);

        } else if (routeCreatorState.plotMode != "auto") {
            mapUpdated({ plotMode: "auto" });
        }
    }


    function setUpMap() {

        map = new microsoft.Maps.Map(mapRef.current,
            {
                credentials: "AlcdeD51Jzcz_FNPntnbpLZ9KCFoGdwLXBOAFza7A_H6r-v_Mbi8DzoWccMWeZjp",
                mapTypeId: microsoft.Maps.MapTypeId.ordnanceSurvey,
                showZoomButtons: false,
                showLocateMeButton: false,
                showMapTypeSelector: false
            });

        map.setView({ center: new microsoft.Maps.Location(centre[0], centre[1] ), zoom: zoom });

        microsoft.Maps.Events.addHandler(map, 'viewchangeend', handleMapChanged);
        microsoft.Maps.Events.addHandler(map, 'click', handleMapClick);

        handleMapLoad(); 
    }

    function handleMapLoad() {
        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY,
            region: "uk"
        });

        var location = locationRef.current;
        $(location).autocomplete({
            source: function (request, response) {
                geo.find(request.term, function (err, res) {
                    var results = new Array();
                    if (res[0]) {
                        geocoder.firstItem = res[0];
                        for (var i = 0; i < res.length; i++) {
                            res[i].label = res[i].formatted_address;
                            results.push(res[i]);
                        }
                        response(results);
                    }
                    else {
                        response();
                    }
                });

            },
            select: function (event, ui) {
                $(location).val(ui.item.formatted_address);
                map.setView({ center: new microsoft.Maps.Location(ui.item.location.lat, ui.item.location.lng), zoom: 14 });
                mapUpdated({ zoom: 14, centre: [ui.item.location.lat, ui.item.location.lng], reprimeZoom: true  });
            }
        });

        var zoomIn = zoomInRef.current;
        $(zoomIn).unbind('click');
        $(zoomIn).click(() => {
            let zoom = map.getZoom();
            zoom = zoom + 1
            map.setView({ zoom: zoom });
            mapUpdated({ zoom: zoom });
        })

        var zoomOut = zoomOutRef.current;
        $(zoomOut).unbind('click');
        $(zoomOut).click(() => {
            let zoom = map.getZoom();
            zoom = zoom - 1
            map.setView({ zoom: zoom });
            mapUpdated({ zoom: zoom });
        })
    }


    function onSearch() {
        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY,
            region: "uk"
        });
        var location = locationRef.current;
        geo.find($(location).val(), function (err, res) {
            if (res[0]) {
                geocoder.firstItem = res[0];
                map.setCenter({ lat: res[0].location.lat, lng: res[0].location.lng });
                map.setZoom(14);
                mapUpdated({ zoom: 14, centre: [res[0].location.lat, res[0].location.lng] });
            }
            else {
                alert('No Results Found!');
            }
        });
    }

    function handleMapClick(e) {
        if (routeCreatorState.createMode == "draw") {
            if (routePoints.length == 0) {
                var startPoint = standardisePoint({ lat: e.location.latitude, lng: e.location.longitude });
                addRoutePoints([startPoint]);
                routePoints.push(startPoint);
                var marker = createMarker(startPoint, true);
                markers.push(marker)
            }
            else {
                if (routeCreatorState.plotMode == "auto") {
                    getDirections(routePoints[routePoints.length - 1], { lat: e.location.latitude, lng: e.location.longitude }, routeCreatorState.autoMode).then(directions => {
                        directions.splice(0, 1); //take off start point
                        var pointsToAdd = [];
                        directions.map((point) => {
                            point = standardisePoint(point);
                            routePoints.map(p => {
                                if (p.lat === point.lat && p.lng === point.lng) {
                                    point.lat = point.lat + 0.00001;
                                    point.lng = point.lng + 0.00001;
                                    point = standardisePoint(point);
                                }
                            })
                            pointsToAdd.push(point);
                        })
                        addRoutePoints([...pointsToAdd]);
                        updateRoute([...pointsToAdd])
                    })

                } else {
                    var newPoint = { lat: e.location.latitude, lng: e.location.longitude }
                    newPoint = standardisePoint(newPoint);
                    addRoutePoints([newPoint]);
                    updateRoute([newPoint])
                }
            }
        }
    }

    function updateRoute(newPoints) {
        newPoints.map((point) => {
            routePoints.push(point);
            var marker = createMarker(point, false);
            markers.push(marker)
        })

        reDrawRoute(routePoints);
    }

    function reDrawRoute(points) {

        var msPoints = convertToMsPoint(points); 

        if (draftPolyline) {
            map.entities.remove(draftPolyline);
        }

        draftPolyline = new microsoft.Maps.Polyline(msPoints, { strokeColor: '#14a4ff', strokeThickness: 3 });
        map.entities.push(draftPolyline);

        microsoft.Maps.Events.addHandler(draftPolyline, 'click', insertPoint);
    }

    function insertPoint(e) {
        if (routeCreatorState.createMode == "edit") {
            var point = standardisePoint({ lat: e.location.latitude, lng: e.location.longitude });
            var index = getRouteClickedInsertionIndex(point, routePoints);
            if (index != -1) {

                routePoints.splice(index, 0, point);
                reDrawRoute(routePoints);

                var marker = createMarker(point, false);
                markers.push(marker)

                insertRoutePoint(point, index);
            }
        }
    }

    function createMarker(point, firstpoint) {

        var msPoint = new microsoft.Maps.Location(point.lat, point.lng)
        var marker = new microsoft.Maps.Pushpin(msPoint,
            {
                draggable: true,
                icon: !firstpoint ? '/resources/images/routes/create/spot6.png' : '/resources/images/start-marker.png',
                width: !firstpoint ? 7 : 29,
                height: !firstpoint ? 7 : 50,
                anchor: !firstpoint ? new microsoft.Maps.Point(3, 3) : new microsoft.Maps.Point(15, 47)
            });

        microsoft.Maps.Events.addHandler(marker, 'dragstart', repositionMarker);
        microsoft.Maps.Events.addHandler(marker, 'drag', repositioningMarker);
        microsoft.Maps.Events.addHandler(marker, 'dragend', repositionedMarker);
        microsoft.Maps.Events.addHandler(marker, 'click', deletePoint);
        map.entities.push(marker);
        return marker;
    }

    function deletePoint(e) {
        if (routeCreatorState.createMode == "edit") {
            var location = e.target.getLocation();
            var pointToDelete = standardisePoint({ lat: location.latitude, lng: location.longitude });

            var deletionIndex = 0;
            routePoints.map((p, id) => {
                if (p.lat == pointToDelete.lat && p.lng == pointToDelete.lng) {
                    routePoints.splice(id, 1);
                    markers.splice(id, 1);
                    deletionIndex = id;
                }

                if (deletionIndex == 0) {
                    markers[0].setOptions({ icon: '/resources/images/start-marker.png', width: 29, height: 50, anchor: new microsoft.Maps.Point(15, 47) });
                }
            });
            map.entities.remove(e.target);
            reDrawRoute(routePoints);
            deleteRoutePoint(deletionIndex);
        }
    }

    //------ HERE -------------

    function repositionMarker(e) {
        var location = e.target.getLocation();
        movingMarkerPosition = standardisePoint({ lat: location.latitude, lng: location.longitude });
        markerIsMoving = true;
    }


    function repositioningMarker(e) {

        var location = e.target.getLocation();
        movingMarkerNewPosition = standardisePoint({ lat: location.latitude, lng: location.longitude  });

        routePoints.map((p, idx) => {
            if (p.lat == movingMarkerPosition.lat && p.lng == movingMarkerPosition.lng) {
                p.lat = movingMarkerNewPosition.lat;
                p.lng = movingMarkerNewPosition.lng;
                p.elevation = null;
                movingMarkerIndex = idx;
            }
        });

        reDrawRoute(routePoints, true);

        movingMarkerPosition = movingMarkerNewPosition;
    }

    function repositionedMarker() {
        setTimeout(() => { markerIsMoving = false; }, 500);//Set on timeout to avoid ghost clicks
        moveRoutePoint(movingMarkerPosition, movingMarkerIndex);
    }

    function handleMapChanged() {
        var mapCentre = map.getCenter();
        var mapZoom = map.getZoom();
        mapUpdated({ centre: [mapCentre.latitude, mapCentre.longitude], zoom: mapZoom });
    }

    function onMapChanged(mapType) {
        mapUpdated({ mapType: mapType });
    }


    return (
        <React.Fragment>
            {
                processing ?
                    <Spinner /> : (

                        <React.Fragment>
                            <div className="create-toolbar col-12">
                                <div className="map-controls row">
                                    <div className="map-title col-6 col-sm-8">
                                        <span className="h4 ml-2" title={routeCreatorState.routeId ? `Edit ${routeCreatorState.routeName}` : "Create"} >
                                            {routeCreatorState.routeId ? `Edit ${routeCreatorState.routeName}` : "Create"}
                                        </span>
                                    </div>
                                    <div className="map-center col-6 col-sm-4">
                                        <div className="input-group mb-0">
                                            <input ref={locationRef} type="text" className="form-control form-control-sm" placeholder="Map Center..." aria-label="Location Search" />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={onSearch}></span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-map-container">
                                <div className="zoom-controls btn-group" role="group">
                                    <button ref={zoomInRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-plus" /></button>
                                    <button ref={zoomOutRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-minus" /></button>
                                </div>
                                <div className="leaflet-container">
                                    <div key={`${routeCreatorState.plotMode}:${draftRoute.future.length}:${routeCreatorState.createMode}:${mapVariant}`} ref={mapRef} id="bing-map"></div>
                                </div>
                            </div>
                        </React.Fragment>
                    )
            }
        </React.Fragment>
    );

}

/*
 
<div className="input-group-prepend" >
    <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-crosshairs" onClick={onSetUserLocation}></span></button>
</div>
 
 */


CreateRouteBingMapView.propTypes =
{
    mapVariant: PropTypes.string,
    centre: PropTypes.array,
    zoom: PropTypes.number,
    points: PropTypes.array,
    routeCreatorState: PropTypes.object,
    draftRoute: PropTypes.object.isRequired,
    mapUpdated: PropTypes.func.isRequired,
    addRoutePoints: PropTypes.func.isRequired,
    deleteRoutePoint: PropTypes.func.isRequired,
    moveRoutePoint: PropTypes.func.isRequired,
    insertRoutePoint: PropTypes.func.isRequired,
    setReCentreOnLoad: PropTypes.func.isRequired,
    map: PropTypes.object
}


function mapStateToProps(state) {
    return {
        auth: state.auth,
        draftRoute: state.draftRoute,
        routeCreatorState: state.routeCreatorState
    };
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateRouteBingMapView);



// WEBPACK FOOTER //
// ./src/components/routes/CreateRouteBingMapView.js